<template>
  <div class="modal-card" style="width: auto">
    <section class="modal-card-body p-lg">
      <div class="container">
        <div class="columns">
          <div class="column">
            <span class="subtitle is-3">Мастер создания объекта данных</span>
          </div>
        </div>

        <DataObject
          v-bind="$props"
          :actionType="actionType"
          :actionEmit="actionEmit"
          @addShortCode="addShortCode"
          @editShortCode="editShortCode"
        >
          <template #actions="slotProps">
            <hr />
            <div class="columns">
              <div class="column is-narrow m-t-sm">
                <div class="buttons">
                  <b-button @click="$parent.close()">Отменить</b-button>
                  <b-button
                    @click="tryDuplicateObject()"
                    v-if="slotProps.isEditState"
                    :disabled="slotProps.isIndicatorNotSelected"
                    >Сохранить как</b-button
                  >
                  <b-button
                    type="is-primary"
                    @click="tryCreateObject()"
                    v-if="!slotProps.isEditState"
                    :disabled="slotProps.isIndicatorNotSelected"
                    >Создать</b-button
                  >
                  <b-button
                    type="is-primary"
                    v-else
                    @click="tryEditObject()"
                    :disabled="slotProps.isIndicatorNotSelected"
                    >Сохранить</b-button
                  >
                </div>
              </div>
            </div>
          </template>
        </DataObject>
      </div>
    </section>
  </div>
</template>

<script>
import DataObject from '@/components/shared/DataObject';

export default {
  props: {
    codes: {
      type: Array,
      required: true
    },
    codeHandle: {
      type: Object
    },
    variables: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      title: 'Выберите индикатор',
      actionType: null,
      actionEmit: 0
    };
  },

  components: {
    DataObject
  },

  methods: {
    tryCreateObject() {
      this.actionType = 'create';
      this.actionEmit++;
    },

    tryEditObject() {
      this.actionType = 'edit';
      this.actionEmit++;
    },

    tryDuplicateObject() {
      this.actionType = 'duplicate';
      this.actionEmit++;
    },

    addShortCode(code) {
      this.$emit('addShortCode', code);
      this.$parent.close();
    },

    editShortCode(code) {
      this.$emit('editShortCode', code);
      this.$parent.close();
    }
  }
};
</script>
